<template>
  <div class="comment-container">
    <main>
      <div class="comment-list" v-for="comment in commentList" :key="comment.id">
        <div class="comment-header">
          <div class="c-name"><b>익명</b></div>

          <div v-if="comment.userId == userId && comment.alter != 1" class="ddropdown">
            <button class="dropbtn">
              <img src="../../../../src/assets/images/dropdown.png" class="dropdown" />
            </button>
            <div class="dropdown-content">
              <div @click="alterList(comment)">수정</div>
              <div @click="reset(comment.id)">삭제</div>
            </div>
          </div>
          <div v-else></div>
        </div>

        <div v-if="comment.alter != 1" class="c-content">
          {{ comment.content }}
        </div>
        <div v-else>
          <TextareaAutosize type="text" v-model="alterContent" class="alterInput"></TextareaAutosize>
        </div>

        <div>
          <div v-if="comment.alter != 1" class="c-updateDT">
            {{ comment.updateDT }}
          </div>
          <div v-else>
            <button class="alterComment" v-on:click="alterComment(comment.id)">
              <img src="../../../../src/assets/images/write.png" class="alter-icon" />
            </button>
            <button class="cancelComment" v-on:click="cancelComment">
              <img src="../../../../src/assets/images/close.png" class="alter-icon" />
            </button>
          </div>
        </div>

        <modal-component
          title="댓글을 삭제하시겠어요?"
          :articleID="article.id"
          :commentID="comment.id"
          :show="removeId === comment.id"
          @close="(removeId = 0), (commentId = 0)"
        ></modal-component>
      </div>

      <div class="commentInput" v-if="alter == 0">
        <div>
          <TextareaAutosize
            v-model="newComment.content"
            class="comment-text"
            placeholder="댓글을 입력하세요"
            style="height: 50px"
          >
          </TextareaAutosize>
        </div>
        <div class="inputBtn" v-on:click="createComment">
          <img src="../../../../src/assets/images/send.png" class="input-btn" />
        </div>
      </div>
    </main>
    <modal-component title="내용을 입력하세요" :show="show" @close="show = false"></modal-component>
    <modal-component title="500자 이하로 입력하세요" :show="show2" @close="show2 = false"></modal-component>
  </div>
</template>

<script>
import firebase from 'firebase/app';
import Modal from '../../modal/Modal';
// import {userId} from '../../../const'
import { getTimeStamp } from '../../../api';

export default {
  name: 'Comment',
  props: ['commentList', 'article'],
  components: {
    'modal-component': Modal,
  },
  data: function() {
    return {
      newComment: {
        content: '',
        createDT: getTimeStamp(),
        updateDT: getTimeStamp(),
        articleID: 0,
      },
      // commentList: [],
      alterContent: '',
      show: false,
      show2: false,
      commentIdList: [],
      myComment: '',
      userId: localStorage.getItem('userId'),
      commentId: 0,
      alter: 0,
      removeId: 0,
    };
  },
  watch: {
    // $route: function(to, from) {
    //   //to가 내가 앞으로 갈곳 from이 지금 있는 곳
    //   this.newComment = {};
    //   this.alter = 0;
    // },
  },
  mounted() {
    this.newComment = {};
    this.alter = 0;
  },
  methods: {
    createComment() {
      if (this.newComment.content == '' || this.newComment.content == undefined) {
        this.show = true;
      } else {
        if (this.newComment.content.length > 500) {
          this.show2 = true;
        } else {
          this.newComment.articleID = this.article.id;
          this.newComment.createDT = getTimeStamp();
          this.newComment.updateDT = getTimeStamp();
          this.newComment.userId = localStorage.getItem('userId');
          firebase
            .database()
            .ref('article/' + this.article.id + '/comment/')
            .push(this.newComment);
          this.newComment = {};
          this.article.commentCount = this.article.commentCount + 1;

          // if(this.article.commentCount == 10 && this.article.like < 10){
          //     if(this.article.content.length > 10){
          //         this.article.content = this.article.content.substring(0, 10) + '..'
          //     }
          //     firebase.database().ref('user').on('value', (snapshot)=> {
          //         snapshot.forEach((childSnapshot) =>{
          //             var childData = childSnapshot.val();
          //             this.newCommentPush('https://fcm.googleapis.com/fcm/send', childData, this.article.id, this.article.content) //백그라운드
          //         });
          //     });
          // }
        }
      }
    },
    // newCommentPush(url,token, id, content){
    //     const message = {
    //         notification :{
    //             "body" : "[" + content + "] 게시글이 답변대기목록에 등록되었습니다",
    //             "title": "마음의 소리",
    //             "icon": "favicon.ico",
    //             "click_action": "https://voice-of-maxst.firebaseapp.com/detail/"+id,
    //         },
    //         to : token
    //     }
    //     fetch(url ,{
    //         method: 'POST',
    //         body: JSON.stringify(message),
    //         headers: new Headers({
    //             'Content-type': 'application/json',
    //             'Authorization' : 'key=AAAAQeYL0LE:APA91bEsNgjnX2QbogwvPxB5TN9K7eujE1IOU5-MYPPiGgvgNTr-6dEaO1z0KqtpBe-tHnfY9-X_AzMzKz1aB9GF5niU89vRCYtdj64mmQfbo1usR8Dy-EMcRyvUr-hvUBrqX6WubrfF'
    //         })
    //     }).then(response => {
    //         if (response.status < 200 || response.status >= 400) {
    //             throw 'Error subscribing to topic: '+response.status + ' - ' + response.text();
    //         }
    //     }).catch(e =>{
    //         console.log(e)
    //     })
    // },
    alterList(comment) {
      this.commentId = 0;
      this.commentList = [];
      firebase
        .database()
        .ref('article/' + comment.articleID + '/comment')
        .orderByKey()
        .on('value', snapshot => {
          snapshot.forEach(childSnapshot => {
            var childData = childSnapshot.val();
            var id = childSnapshot.key;
            childData.id = id;
            if (comment.id == id) childData.alter = 1;
            this.commentList.push(childData);
          });
        }),
        firebase
          .database()
          .ref('article/' + comment.articleID + '/comment/')
          .child(comment.id)
          .once('value', data => {
            this.alterContent = data.val().content;
          });
      this.alter = 1;
    },
    alterComment(id) {
      if (this.alterContent == '' || this.alterContent == undefined) {
        this.show = true;
      } else {
        if (this.alterContent.length > 500) {
          this.show2 = true;
        } else {
          this.alter = 0;
          firebase
            .database()
            .ref('article/' + this.article.id + '/comment/')
            .child(id)
            .update({
              content: this.alterContent,
              updateDT: getTimeStamp(),
            });
          this.alterContent = '';
          firebase
            .database()
            .ref('article/')
            .child(this.article.id)
            .update({
              updateDT: getTimeStamp(),
            });
        }
      }
    },
    cancelComment() {
      this.commentId = 0;
      this.alter = 0;
      this.commentList = [];
      firebase
        .database()
        .ref('article/' + this.article.id + '/comment')
        .orderByKey()
        .on('value', snapshot => {
          snapshot.forEach(childSnapshot => {
            var childData = childSnapshot.val();
            var id = childSnapshot.key;
            childData.id = id;
            this.commentList.push(childData);
          });
        });
    },
    saveCommentId(id) {
      if (this.commentId == 0) this.commentId = id;
      else this.commentId = 0;
    },
    reset(id) {
      this.removeId = id;
      this.commentId = 0;
    },
  },
};
</script>

<style scoped>
@import 'Comment.scss';
</style>
